// This file is auto-generated by the Appwrite CLI.
// You can regenerate it by running `appwrite types --language ts ./types`.
export var TransactionType;
(function (TransactionType) {
    TransactionType["DEBIT"] = "DEBIT";
    TransactionType["CREDIT"] = "CREDIT";
})(TransactionType || (TransactionType = {}));
export var Status;
(function (Status) {
    Status["BOOKED"] = "BOOKED";
    Status["PENDING"] = "PENDING";
})(Status || (Status = {}));
export var SyncStatus;
(function (SyncStatus) {
    SyncStatus["SYNCED"] = "synced";
    SyncStatus["PENDING"] = "pending";
    SyncStatus["ERROR"] = "error";
})(SyncStatus || (SyncStatus = {}));
export var BankAccountSyncStatus;
(function (BankAccountSyncStatus) {
    BankAccountSyncStatus["CONNECTED"] = "connected";
    BankAccountSyncStatus["ERROR"] = "error";
    BankAccountSyncStatus["EXPIRED"] = "expired";
    BankAccountSyncStatus["DISABLED"] = "disabled";
})(BankAccountSyncStatus || (BankAccountSyncStatus = {}));
export var BankProvider;
(function (BankProvider) {
    BankProvider["GOCARDLESS"] = "gocardless";
    BankProvider["FIREFLY"] = "firefly";
})(BankProvider || (BankProvider = {}));
export var DateFormat;
(function (DateFormat) {
    DateFormat["DDMMYYYY"] = "DD/MM/YYYY";
    DateFormat["MMDDYYYY"] = "MM/DD/YYYY";
    DateFormat["YYYY_MM_DD"] = "YYYY-MM-DD";
})(DateFormat || (DateFormat = {}));
export var AccountType;
(function (AccountType) {
    AccountType["CHECKING"] = "checking";
    AccountType["SAVINGS"] = "savings";
    AccountType["CREDIT"] = "credit";
    AccountType["INVESTMENT"] = "investment";
    AccountType["OTHER"] = "other";
})(AccountType || (AccountType = {}));
export var BudgetPeriod;
(function (BudgetPeriod) {
    BudgetPeriod["MONTHLY"] = "monthly";
    BudgetPeriod["WEEKLY"] = "weekly";
    BudgetPeriod["YEARLY"] = "yearly";
})(BudgetPeriod || (BudgetPeriod = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["CURRENCY_IS"] = "currency_is";
    TriggerType["AMOUNT_LESS"] = "amount_less";
    TriggerType["AMOUNT_LESS_EQUAL"] = "amount_less_equal";
    TriggerType["AMOUNT_GREATER"] = "amount_greater";
    TriggerType["AMOUNT_GREATER_EQUAL"] = "amount_greater_equal";
    TriggerType["AMOUNT_EQUAL"] = "amount_equal";
    TriggerType["DESCRIPTION_STARTS"] = "description_starts";
    TriggerType["DESCRIPTION_ENDS"] = "description_ends";
    TriggerType["DESCRIPTION_CONTAINS"] = "description_contains";
    TriggerType["DESCRIPTION_NOT_CONTAINS"] = "description_not_contains";
    TriggerType["ACCOUNT_IS"] = "account_is";
    TriggerType["DATE_STARTING_FROM"] = "date_starting_from";
    TriggerType["DATE_UNTIL"] = "date_until";
    TriggerType["DATE_BETWEEN"] = "date_between";
})(TriggerType || (TriggerType = {}));
export var ActionType;
(function (ActionType) {
    ActionType["SET_CATEGORY"] = "set_category";
    ActionType["SET_NOTE"] = "set_note";
    ActionType["SET_ACCOUNT"] = "set_account";
    ActionType["SET_MERCHANT"] = "set_merchant";
})(ActionType || (ActionType = {}));
export var UserPlanType;
(function (UserPlanType) {
    UserPlanType["FREE"] = "free";
    UserPlanType["SMART"] = "smart";
    UserPlanType["PRO"] = "pro";
})(UserPlanType || (UserPlanType = {}));
